import { KUBE_SCENE_LIGHT_MIN_HEIGHT, LIGHT_PIVOT_OFFSET } from '@constants'

/** Eleva la fuente de luz por encima de la cámara cenital en escenas kube (sin paredes). */
export function resolveSceneLightLocalY(
  pivotWorldY: number,
  hasWalls: boolean,
  baseOffset = LIGHT_PIVOT_OFFSET,
): number {
  if (hasWalls) return baseOffset
  return Math.max(baseOffset, KUBE_SCENE_LIGHT_MIN_HEIGHT - pivotWorldY)
}
